export default (form: HTMLFormElement): Record<string, FormDataEntryValue> => {
    const formData = new FormData(form);
    const idx: Record<string, number> = {};
    const objValue: Record<string, FormDataEntryValue> = {};

    for (const [ name, value ] of formData.entries()) {
        if (value) {
            if (-1 === name.indexOf("[]")) {
                objValue[name] = value;
            } else {
                const id = idx[name] || 0;
                idx[name] = id + 1;
                objValue[name.replace("[]", `[${id}]`)] = value;
            }
        }
    }

    return objValue;
};
